/**
 * Customer Addresses Script
 * ------------------------------------------------------------------------------
 * A file that contains scripts highly couple code to the Customer Addresses
 * template.
 *
 * @namespace customerAddresses
 */

import { section } from "@/neon";
import { CountryProvinceSelector } from "@shopify/theme-addresses";

const selectors = {
  addressContainer: "[data-address]",
  addressToggle: "[data-address-toggle]",
  addressCountry: "[data-address-country]",
  addressProvince: "[data-address-province]",
  addressProvinceWrapper: "[data-address-province-wrapper]",
  addressForm: "[data-address-form]",
  addressDeleteForm: "[data-address-delete-form]",
};

const hideClass = "hide";

section("addresses", {
  onLoad() {
    const addresses = this.container.querySelectorAll(
      selectors.addressContainer
    );

    if (addresses.length) {
      const countryProvinceSelector = new CountryProvinceSelector(
        window.theme.allCountryOptionTags
      );

      addresses.forEach(addressContainer => {
        this._initializeAddressForm(countryProvinceSelector, addressContainer);
      });
    }
  },

  _initializeAddressForm(countryProvinceSelector, container) {
    const countrySelector = container.querySelector(selectors.addressCountry);
    const provinceSelector = container.querySelector(selectors.addressProvince);
    const provinceWrapper = container.querySelector(
      selectors.addressProvinceWrapper
    );
    const addressForm = container.querySelector(selectors.addressForm);
    const deleteForm = container.querySelector(selectors.addressDeleteForm);

    const formToggles = container.querySelectorAll(selectors.addressToggle);

    countryProvinceSelector.build(countrySelector, provinceSelector, {
      onCountryChange: provinces =>
        provinceWrapper.classList.toggle(hideClass, !provinces.length),
    });

    formToggles.forEach(button => {
      button.addEventListener("click", () => {
        addressForm.classList.toggle(hideClass);

        formToggles.forEach(innerButton => {
          innerButton.setAttribute(
            "aria-expanded",
            innerButton.getAttribute("aria-expanded") === "true" ? false : true
          );
        });
      });
    });

    if (deleteForm) {
      deleteForm.addEventListener("submit", event => {
        const confirmMessage = deleteForm.getAttribute("data-confirm-message");

        if (
          !window.confirm(
            confirmMessage || "Are you sure you wish to delete this address?"
          )
        ) {
          event.preventDefault();
        }
      });
    }
  },

  onUnload() {},
});
